import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function Rules() {
  return (
    <div className="min-h-screen bg-tribal">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-12 fade-up">
        <p className="text-xs tracking-[0.3em] text-[color:var(--primary)] mb-3">RÈGLES OFFICIELLES</p>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mb-8">Pere Fa'anu'u</h1>

        <div className="space-y-8 text-[color:var(--text-secondary)] text-sm sm:text-base leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">1. Le plateau</h2>
            <p className="mb-3">
              Le jeu se joue sur un quadrillage de 5 × 5 lignes formant <strong>25 intersections</strong> et 16 cellules. Les pions se posent et se déplacent sur les nœuds, jamais à l'intérieur des cellules. Chaque cellule est traversée par ses deux diagonales, qui définissent les chemins autorisés.
            </p>
            <p className="mb-2">
              <strong className="text-[color:var(--text-primary)]">Système de coordonnées</strong> : chaque intersection est repérée par
              {" "}<code className="px-1 rounded bg-[color:var(--surface)]">(x, y)</code> où :
            </p>
            <ul className="list-disc list-inside ml-2 space-y-1 mb-3">
              <li><strong>x</strong> = colonne, de 0 (gauche) à 4 (droite)</li>
              <li><strong>y</strong> = rangée, de 0 (bas) à 4 (haut)</li>
            </ul>
            <p>
              Les quatre coins du plateau sont donc : <code>(0,0)</code> bas-gauche · <code>(4,0)</code> bas-droite · <code>(0,4)</code> haut-gauche · <code>(4,4)</code> haut-droite. Le centre est <code>(2,2)</code>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">2. Mise en place</h2>
            <p>
              Chaque joueur dispose de <strong>10 pions</strong>. Par défaut, le Joueur A (coquillages blancs) occupe les rangées y=0 et y=1 ; le Joueur B (galets noirs) occupe y=3 et y=4. La rangée centrale y=2 reste vide. Vous pouvez aussi placer vos pions manuellement via la page <Link to="/setup" className="text-[color:var(--primary)] underline">Configurer le plateau</Link>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">3. Déplacement</h2>
            <p>
              Un pion normal avance d'une intersection à la fois : <strong>avant, gauche, droite, et diagonales avant</strong>. Il ne peut <strong>jamais reculer</strong>. L'intersection d'arrivée doit être libre.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">4. Capture (Amu)</h2>
            <p>
              Pour capturer, sautez par-dessus un pion adverse adjacent vers une intersection vide. Les <strong>captures multiples</strong> sont obligatoires en chaîne. La <strong>prise est prioritaire</strong> : si une capture est possible, vous devez la jouer.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">5. Le Ari'i (Roi)</h2>
            <p>
              Un pion devient Ari'i <strong>uniquement</strong> en atteignant l'un des deux coins extrêmes du camp adverse — pour A : (0,4) et (4,4) ; pour B : (0,0) et (4,0). Le Ari'i se déplace dans <strong>les 8 directions</strong> et peut <strong>glisser sur plusieurs intersections libres</strong> en ligne droite. En capture, il peut sauter un adversaire et atterrir sur n'importe quelle intersection libre au-delà. <strong>Immunité sacrée</strong> : seul un Ari'i peut capturer un Ari'i.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">6. Fin de partie</h2>
            <p>
              Victoire par <strong>extermination</strong> (tous les pions adverses capturés) ou par <strong>blocage</strong> (l'adversaire n'a plus aucun coup légal).
            </p>
          </section>
        </div>

        <div className="mt-12">
          <Link to="/lobby" className="px-6 py-3 rounded-md btn-gold text-sm inline-block" data-testid="rules-play-cta">
            Jouer maintenant →
          </Link>
        </div>
      </main>
    </div>
  );
}
